var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scene-list"},_vm._l((_vm.scenes),function(scene){return _c('Scene',{key:scene.id,attrs:{"scene-id":scene.id,"scene-name":scene.name,"image-url":scene.imageUrl}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }